export default {"src":"/_next/static/media/gray-room-names-en.78d75985.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};